// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (min-width:768px){.footerlegal__items{margin:-15px}}.footerlegal__item{padding-bottom:30px}@media (min-width:768px){.footerlegal__item{padding:15px}}", ""]);
// Exports
module.exports = exports;
